import { TeamInitialState, TeamsModel } from "@purusha/purusha";

export const TeamsInitialState: TeamsModel = {
  list: [TeamInitialState],
  action: "empty"
};
